(() => {
  'use strict';
  const routes = window.caressenceRoutes || {cart: '/cart', add: '/cart/add', change: '/cart/change'};
  let mutationQueue = Promise.resolve();
  let lastFocus = null;
  let toastTimer;
  const money = value => new Intl.NumberFormat(document.documentElement.lang || 'de-DE', {style: 'currency', currency: window.caressenceCurrency || 'EUR'}).format(value / 100);
  const announce = message => {
    const toast = document.getElementById('Toast');
    if (!toast) return;
    toast.textContent = message;
    toast.classList.add('show');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => toast.classList.remove('show'), 4000);
  };
  const openDialog = id => {
    const dialog = document.getElementById(id);
    if (!dialog || typeof dialog.showModal !== 'function') return false;
    lastFocus = document.activeElement;
    if (!dialog.open) dialog.showModal();
    return true;
  };
  const closeDialog = dialog => {
    dialog?.close();
    if (lastFocus?.isConnected) lastFocus.focus();
  };
  const enqueue = task => {
    mutationQueue = mutationQueue.then(task, task);
    return mutationQueue;
  };
  const renderCart = payload => {
    const rendered = payload.sections?.['cart-drawer'];
    if (!rendered) return false;
    const parsed = new DOMParser().parseFromString(rendered, 'text/html');
    const next = parsed.getElementById('CartDrawerContent');
    const current = document.getElementById('CartDrawerContent');
    if (!next || !current) return false;
    current.replaceWith(next);
    const count = next.querySelector('[data-cart-count]')?.textContent?.trim() || '0';
    document.querySelectorAll('[data-cart-count]').forEach(node => {node.textContent = count;});
    return true;
  };
  const request = async (url, options) => {
    const response = await fetch(url, {...options, credentials: 'same-origin', headers: {'Accept': 'application/json', ...options?.headers}});
    const payload = await response.json();
    if (!response.ok) throw new Error(payload.description || payload.message || 'Das hat leider nicht geklappt. Bitte versuche es erneut.');
    return payload;
  };
  document.addEventListener('click', event => {
    const opener = event.target.closest('[data-open-dialog]');
    if (opener && openDialog(opener.dataset.openDialog)) {event.preventDefault();return;}
    const closer = event.target.closest('[data-close-dialog]');
    if (closer) {const dialog = closer.closest('dialog');if (dialog) closeDialog(dialog);}
    const quantityStep = event.target.closest('[data-quantity-step]');
    if (quantityStep) {
      const input = quantityStep.closest('.quantity-control').querySelector('input');
      if (!input) return;
      const min = Number(input.min) || 1, max = Number(input.max) || Infinity, step = Number(input.step) || 1;
      const next = (Number(input.value) || min) + Number(quantityStep.dataset.quantityStep) * step;
      input.value = String(Math.max(min, Math.min(max, next)));
      input.dispatchEvent(new Event('change', {bubbles: true}));
    }
    const thumbnail = event.target.closest('[data-image-src]');
    if (thumbnail) {
      const image = thumbnail.closest('.product-gallery')?.querySelector('.gallery-main');
      if (image) {image.src = thumbnail.dataset.imageSrc;image.removeAttribute('srcset');}
    }
    const cartChange = event.target.closest('[data-cart-change]');
    if (cartChange) {
      event.preventDefault();
      document.querySelectorAll('[data-cart-change]').forEach(button => {button.disabled = true;});
      enqueue(async () => {
        try {
          const payload = await request(routes.change + '.js', {method: 'POST', headers: {'Content-Type': 'application/json'}, body: JSON.stringify({id: cartChange.dataset.key, quantity: Number(cartChange.dataset.quantity), sections: ['cart-drawer'], sections_url: location.pathname})});
          if (!renderCart(payload)) location.assign(routes.cart);
        } catch (error) {
          const message = document.querySelector('[data-cart-error]');
          if (message) message.textContent = error.message;
        } finally {
          document.querySelectorAll('[data-cart-change]').forEach(button => {button.disabled = false;});
        }
      });
    }
    if (event.target.matches('dialog')) {
      const box = event.target.getBoundingClientRect();
      if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) closeDialog(event.target);
    }
    if (event.target.closest('.mobile-nav a')) document.querySelector('.mobile-menu')?.removeAttribute('open');
  });
  document.addEventListener('submit', event => {
    const form = event.target;
    if (form.matches('.address-delete') && !window.confirm('Diese Adresse löschen?')) {event.preventDefault();return;}
    if (!form.matches('[data-product-form]')) return;
    if (event.submitter && event.submitter.closest('.shopify-payment-button')) return;
    event.preventDefault();
    const button = form.querySelector('button[type="submit"]');
    const message = form.querySelector('[data-form-message]');
    const original = button?.innerHTML;
    if (message) message.textContent = '';
    if (button) {button.disabled = true;button.setAttribute('aria-busy', 'true');button.textContent = 'Wird hinzugefügt …';}
    const data = new FormData(form);
    data.set('sections', 'cart-drawer');
    data.set('sections_url', location.pathname);
    enqueue(async () => {
      try {
        const payload = await request(routes.add + '.js', {method: 'POST', body: data});
        if (!renderCart(payload) || !openDialog('CartDialog')) {location.assign(routes.cart);return;}
        announce('In deinen Warenkorb gelegt.');
      } catch (error) {if (message) message.textContent = error.message;else announce(error.message);}
      finally {
        if (button) {button.innerHTML = original;button.disabled = false;button.removeAttribute('aria-busy');}
      }
    });
  });
  const initializeProducts = scope => {
    scope.querySelectorAll('[data-product-section]').forEach(section => {
      if (section.dataset.initialized) return;
      section.dataset.initialized = 'true';
      const select = section.querySelector('[data-variant-select]');
      const json = section.querySelector('[data-product-variants]');
      if (!select || !json) return;
      let variants;
      try {variants = JSON.parse(json.textContent);} catch (_) {return;}
      select.addEventListener('change', () => {
        const variant = variants.find(item => String(item.id) === select.value);
        if (!variant) return;
        const price = section.querySelector('[data-current-price]');
        const compare = section.querySelector('[data-compare-price]');
        const button = section.querySelector('[data-add-button]');
        const label = section.querySelector('[data-add-label]');
        if (price) price.textContent = money(variant.price);
        if (compare) {compare.hidden = !(variant.compare_at_price > variant.price);compare.textContent = variant.compare_at_price > variant.price ? money(variant.compare_at_price) : '';}
        if (button) button.disabled = !variant.available;
        if (label) label.textContent = variant.available ? 'In den Warenkorb' : 'Ausverkauft';
        const quantity = section.querySelector('[name="quantity"]');
        if (quantity) {
          quantity.min = String(variant.quantity_rule?.min || 1);
          quantity.step = String(variant.quantity_rule?.increment || 1);
          if (variant.quantity_rule?.max) quantity.max = String(variant.quantity_rule.max);else quantity.removeAttribute('max');
          quantity.value = quantity.min;
        }
        if (variant.featured_image?.src) {const image = section.querySelector('.gallery-main');if (image) {image.src = variant.featured_image.src;image.removeAttribute('srcset');}}
        const url = new URL(location.href);url.searchParams.set('variant', variant.id);history.replaceState({}, '', url);
      });
    });
  };
  initializeProducts(document);
  document.addEventListener('shopify:section:load', event => initializeProducts(event.target));
  document.querySelectorAll('[data-address-country]').forEach(country => {
    const form = country.closest('form');
    const province = form.querySelector('[data-address-province]');
    const wrapper = form.querySelector('[data-address-province-wrapper]');
    const defaultCountry = country.dataset.default;
    if (defaultCountry) {
      const found = [...country.options].find(option => option.value === defaultCountry || option.textContent === defaultCountry);
      if (found) found.selected = true;
    }
    const update = () => {
      let provinces = [];
      try {provinces = JSON.parse(country.selectedOptions[0]?.dataset.provinces || '[]');} catch (_) {}
      province.replaceChildren();
      provinces.forEach(([value, name]) => province.add(new Option(name, value)));
      wrapper.hidden = provinces.length === 0;
      province.disabled = provinces.length === 0;
      const selected = [...province.options].find(option => option.value === province.dataset.default || option.textContent === province.dataset.default);
      if (selected) selected.selected = true;
    };
    update();
    country.addEventListener('change', update);
  });
  document.addEventListener('change', event => {if (event.target.matches('[data-submit-on-change]')) event.target.form?.requestSubmit();});
  const loadPrivacy = () => new Promise((resolve, reject) => {
    if (window.Shopify?.customerPrivacy) return resolve(window.Shopify.customerPrivacy);
    if (!window.Shopify?.loadFeatures) return reject(new Error('Die Shopify-Datenschutzeinstellungen sind gerade nicht erreichbar. Bitte lade die Seite erneut.'));
    window.Shopify.loadFeatures([{name: 'consent-tracking-api', version: '0.1'}], error => error ? reject(error) : resolve(window.Shopify.customerPrivacy));
  });
  const syncPrivacy = api => {
    const consent = api.currentVisitorConsent();
    document.querySelectorAll('[data-consent-option]').forEach(input => {input.checked = consent[input.name] === 'yes';});
  };
  document.addEventListener('click', async event => {
    const privacyButton = event.target.closest('[data-cookie-settings]');
    const consentButton = event.target.closest('[data-consent]');
    if (!privacyButton && !consentButton) return;
    const dialog = document.getElementById('PrivacyDialog');
    const message = dialog?.querySelector('[data-privacy-message]');
    if (privacyButton) openDialog('PrivacyDialog');
    try {
      const api = await loadPrivacy();
      if (privacyButton) {syncPrivacy(api);return;}
      const choice = consentButton.dataset.consent;
      const consent = {preferences: false, analytics: false, marketing: false};
      Object.keys(consent).forEach(key => {consent[key] = choice === 'all' || choice === 'selected' && !!dialog.querySelector('[name="' + key + '"]')?.checked;});
      consent.sale_of_data = false;
      dialog.querySelectorAll('[data-consent]').forEach(button => {button.disabled = true;});
      api.setTrackingConsent(consent, () => {
        dialog.querySelectorAll('[data-consent]').forEach(button => {button.disabled = false;});
        closeDialog(dialog);
        announce('Deine Cookie-Einstellungen wurden gespeichert.');
      });
    } catch (error) {
      if (message) message.textContent = error.message || 'Einstellungen konnten nicht geladen werden.';
      dialog?.querySelectorAll('[data-consent]').forEach(button => {button.disabled = false;});
    }
  });
  const privacyDialog = document.getElementById('PrivacyDialog');
  if (privacyDialog?.dataset.autoBanner === 'true') loadPrivacy().then(api => {if (api.shouldShowBanner()) {syncPrivacy(api);openDialog('PrivacyDialog');}}).catch(() => {});
})();
